import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=db414976&scoped=true&"
import script from "./growth.vue?vue&type=script&lang=js&"
export * from "./growth.vue?vue&type=script&lang=js&"
import style0 from "./growth.vue?vue&type=style&index=0&id=db414976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db414976",
  null
  
)

export default component.exports